import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, handleBackendFormErrors, tailFormItemLayout, unexpectedError } from '../../../common_functions';

const MountType = props => {
  const { section, id } = useParams();
  const [dimension, setDimension] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        if (id !== 'new') {
          let { data } = await props.getItem('mount_type', id);
          setDimension(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    try {
      setLoading(true);
      let newState = { ...dimension, ...values };
      const response = await props.saveItem('mount_type', newState);
      if (response) {
        notification['success']({
          message: 'Mount condition saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/mount-conditions`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/mount-conditions" }, { title: "Mount Conditions", href: "/settings/mount-conditions" }, { title: id != 'new' ? `Edit Mount Conditions` : 'Create Mount Conditions' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id != 'new' ? `Edit Mount Condition: ${id}` : 'Create Mount Condition'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Name is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter name" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/mount-conditions')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_mount_conditions, !!dimension ? dimension.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default MountType;
